import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Common from '../Common';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import $ from "jquery";

function Master_sanction_header() {
    const navigate = useNavigate();
    const [id, setId] = useState("");
    const [name, setName] = useState("");
    const [filterLimit, setFilterLimit] = useState('10');
    const [sourceData, setSourcedata] = useState([]);
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [dataid, setDataid] = useState("");
    const [type, setType] = useState("");
    const [cname, setCname] = useState("");
    const [scrMode, setScrMode] = useState("");
    const [viewObj, setViewObj] = useState();
    const sid = sessionStorage.getItem('sessionId');

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'MASTER_SANCTIONS_HEADER'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const showList = () => {
        $(".loader").show();
        const obj = {
            id: id,
            name: name,
            filterLimit: filterLimit,
        }
        Common.callApi(Common.apisanctionsheader, [sid, 'getList', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setSourcedata(resp);
            $(".loader").hide();
        });
    }

    const getData = (srno) => {
        setScrMode('V');
        Common.callApi(Common.apisanctionsheader, [sid, 'view', srno], (result) => {
            let res = JSON.parse(result);
            res = res[0];
            // setDataid(res.msh_data_id);
            // setCname(res.msh_name);
            // setType(res.msh_entity_type);
            setViewObj(res);
        });
    }

    function BackForm() {
        setScrMode("");
    }

    return (
        <>
            <LoginHeader />
            <Menu />

            <Container fluid>
                {scrMode === "" ?
                    <>
                        <Row>
                            <Col>
                                <h2>Sanction List</h2>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Data Id </Form.Label>
                                    <Form.Control type="text" placeholder="Data Id" maxLength={10}
                                        value={id}
                                        onChange={(e) => Common.validateNumValue(e.target.value, setId)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control type="text" placeholder="Name" maxLength={50}
                                        value={name}
                                        onChange={(e) => Common.validateAlpValue(e.target.value, setName)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Limit<span className="text-danger">*</span></Form.Label>
                                    <Form.Select value={filterLimit} onChange={e => setFilterLimit(e.target.value)}
                                        required>
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="50">50</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col style={{ marginTop: "34px" }}>
                                <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={(e) => showList()} >Search</Button>
                            </Col>
                        </Row>
                        &nbsp;&nbsp;

                        <>
                            <Row>
                                <Col>
                                    <Table responsive striped bordered hover>
                                        <thead>
                                            <tr>
                                                {userRight.query === "1" ? <th></th> : null}
                                                {/* <th className="textRight">Sr No</th> */}
                                                <th>Sanction</th>
                                                <th>Entity Type</th>
                                                <th>Data Id</th>
                                                <th>Name</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sourceData.map((res, index) =>
                                                <tr key={res.msh_data_id}>
                                                    {userRight.query === "1" ?
                                                        <td className="textCenter" >
                                                            <span className="handCursor colorThemeBlue" onClick={() => getData(res.msh_data_id)}>
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </span>
                                                        </td>
                                                        : null
                                                    }
                                                    {/* <td className="textRight">{index}</td> */}
                                                    <td>{res.msh_master}</td>
                                                    <td>{res.msh_entity_type === 'I' ? 'Individual' : viewObj?.msh_entity_type === 'E' ? 'Entity' : viewObj?.msh_entity_type === 'V' ? 'View' : ''}</td>
                                                    <td>{res.msh_data_id}</td>
                                                    <td>{res.msh_name}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </>
                        :
                        <Row><Col>&nbsp;</Col></Row>
                        <Row><Col>&nbsp;</Col></Row>
                        <Row><Col>&nbsp;</Col></Row>
                    </>

                    : scrMode === "V" ?
                        <>
                            <Row>
                                <Col>
                                    <Button
                                        variant="outline-danger"
                                        className="btn btn-sm custom-btn"
                                        style={{ padding: "2px 8px", fontSize: "16px", height: "30px", width: "90px" }}
                                        onClick={(e) => BackForm()}
                                    >
                                        Back
                                    </Button>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>Name :</h5>
                                    <span>{viewObj?.msh_name}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>Master:</h5>
                                    <span>{viewObj?.msh_master}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>Entity Type:</h5>
                                    <span>{viewObj?.msh_entity_type === 'I' ? 'Individual' : viewObj?.msh_entity_type === 'E' ? 'Entity' : viewObj?.msh_entity_type === 'V' ? 'View' : ''}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>Data Id:</h5>
                                    <span>{viewObj?.msh_data_id}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>Nationality:</h5>
                                    <span>{viewObj?.msh_nationality}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>DOB Year:</h5>
                                    <span>{viewObj?.msh_date_of_birth_year}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>Dob Type:</h5>
                                    <span>{viewObj?.msh_date_of_birth_type} </span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>First Name :</h5>
                                    <span>{viewObj?.msh_first_name}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>Second Name:</h5>
                                    <span>{viewObj?.msh_second_name}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>Third Name:</h5>
                                    <span>{viewObj?.msh_third_name}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>List Type:</h5>
                                    <span>{viewObj?.msh_list_type}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>Reference Number:</h5>
                                    <span>{viewObj?.msh_reference_number}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>Listed:</h5>
                                    <span>{viewObj?.msh_listed_on}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>Title:</h5>
                                    <span>{viewObj?.msh_title}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>Place Of Birth City:</h5>
                                    <span>{viewObj?.msh_place_of_birth_city}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>Place Of Birth State:</h5>
                                    <span>{viewObj?.msh_place_of_birth_state}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>Place Of Birth Country:</h5>
                                    <span>{viewObj?.msh_place_of_birth_country}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>Comments1:</h5>
                                    <span>{viewObj?.msh_comments1}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>Alias Name:</h5>
                                    <span>{viewObj?.msh_alias_name}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <h5 style={{ display: "inline", marginRight: "5px" }}>date:</h5>
                                    <span>{viewObj?.msh_updatedon}</span>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <Button
                                        variant="outline-danger"
                                        className="btn btn-sm custom-btn"
                                        style={{ padding: "2px 8px", fontSize: "16px", height: "30px", width: "90px" }}
                                        onClick={(e) => BackForm()}
                                    >
                                        Back
                                    </Button>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row><Col>&nbsp;</Col></Row>
                        </>
                        : null}
            </Container>
        </>
    )
}

export default Master_sanction_header;
